/**
 * Token storage.
 *
 * v1 注意事項：access_token 暫存 localStorage（XSS 風險已知）。
 * 後續 (M2+) 規劃遷移為：
 *   - access_token 留 in-memory（避免 XSS 提取）
 *   - refresh_token 走 httpOnly + SameSite=Strict cookie（由 c-jwt agent 提供）
 *   - 啟動時呼 /auth/refresh 重建 access_token
 */

const STORAGE_KEY = 'boat.access_token';
const LOGOUT_EVENT = 'boat:auth:logout';

export function storeAccessToken(token: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, token);
  } catch {
    // private mode / quota — 忽略，下次請求會 401 再走流程
  }
}

export function getAccessToken(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function clearAccessToken(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
  // 廣播登出事件給 React 元件（App.tsx 監聽 → 導向 /login）
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(LOGOUT_EVENT));
  }
}

export function isAuthenticated(): boolean {
  return Boolean(getAccessToken());
}

export const AUTH_EVENT = {
  LOGOUT: LOGOUT_EVENT,
} as const;
